<template>
	<section class="small-12 columns pageNav flex">
		<nav class="small-12 columns">
			<ul class="small-12 flex vertical-align border-bottom">
				<li class="flex vertical-align">
					<router-link class="flex vertical-align justify-center" :to="{ name: 'SettingsAccount' }">
						Account
					</router-link>
				</li>
				<li class="flex vertical-align">
					<router-link class="flex vertical-align justify-center" :to="{ name: 'SettingsPolicies' }">
						Property Policies
					</router-link>
				</li>
				<li class="flex vertical-align">
					<router-link class="flex vertical-align justify-center router-link-exact-active router-link-active" :to="{ name: 'SettingsCompany' }" v-if="$route.name == 'SettingsCompany' || $route.name == 'AddCompany'">
						Company
					</router-link>
					<router-link class="flex vertical-align justify-center" :to="{ name: 'SettingsCompany' }" v-else>
						Company
					</router-link>
				</li>
				<li class="flex vertical-align" v-if="company">
					<router-link class="flex vertical-align justify-center" :to="{ name: 'SettingsResidents' }">
						Residents Site
					</router-link>
				</li>
				<li class="flex vertical-align" v-if="company">
					<router-link class="flex vertical-align justify-center" :to="{ name: 'SettingsPayments' }">
						Payments
					</router-link>
				</li>
			</ul>
		</nav>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SettingsNav',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			futureItem: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>